import { defineComponent as _defineComponent } from 'vue'
import { toRefs, ref, watch, useContext, computed } from '@nuxtjs/composition-api';
import { useMobile } from "~/core/composables/useMobile";

interface Props {
    visible: boolean;
    width?: string;
    fullscreen?: boolean,
    topOffset?: string,
    lockScroll?: boolean,
    customClass?: string,
    appendToBody?: boolean;
    modalAppendToBody?: boolean;
    closeOnClickModal?: boolean;
    closeOnPressEscape?: boolean;
    destroyOnClose?: boolean;
    center?: boolean;
    modal?: boolean;
    beforeClose?: Function;
    showBack?: boolean;
    showClose?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FullscreenAffility',
  props: {
    visible: { type: Boolean, default: false },
    width: null,
    fullscreen: { type: Boolean, default: true },
    topOffset: null,
    lockScroll: { type: Boolean, default: true },
    customClass: null,
    appendToBody: { type: Boolean, default: true },
    modalAppendToBody: { type: Boolean, default: true },
    closeOnClickModal: { type: Boolean, default: true },
    closeOnPressEscape: { type: Boolean, default: true },
    destroyOnClose: { type: Boolean, default: true },
    center: { type: Boolean, default: false },
    modal: { type: Boolean, default: true },
    beforeClose: null,
    showBack: { type: Boolean, default: false },
    showClose: { type: Boolean, default: true }
  },
  emits: ['update:visible', 'close', 'open', 'closed', 'opened', 'back'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { visible: boolean, width?: string, fullscreen: boolean, topOffset?: string, lockScroll: boolean, customClass?: string, appendToBody: boolean, modalAppendToBody: boolean, closeOnClickModal: boolean, closeOnPressEscape: boolean, destroyOnClose: boolean, center: boolean, modal: boolean, beforeClose?: Function, showBack: boolean, showClose: boolean };





const {
    visible,
    width,
    fullscreen,
    topOffset,
    lockScroll,
    customClass,
    appendToBody,
    modalAppendToBody,
    closeOnClickModal,
    closeOnPressEscape,
    destroyOnClose,
    center,
    modal,
    beforeClose,
    showClose,
} = toRefs(props);

const nuxt = useContext();
const internalVisible = ref(visible.value);
const currentColorMode = nuxt.$colorMode;
const isMobile = useMobile();

const currentColorModeValue = computed(() => {
    return currentColorMode.value || 'light';
})

watch(visible, (value, oldVal) => {
    if (!!value === !!oldVal) return;
    internalVisible.value = value;
    $emit('update:visible', value);
});

watch(internalVisible, (value) => {
    if (value === visible.value) return;
    $emit('update:visible', value);
});


return { __sfc: true,$emit, props, visible, width, fullscreen, topOffset, lockScroll, customClass, appendToBody, modalAppendToBody, closeOnClickModal, closeOnPressEscape, destroyOnClose, center, modal, beforeClose, showClose, nuxt, internalVisible, currentColorMode, isMobile, currentColorModeValue }
}

})